<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtube.com/shorts/7oP-pcWNUUo"
    >
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('link_5.png')" alt="IDOLY Comeback Stageの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('img_contents01_01.png')"
                     alt="選んだコンセプトにあわせて写り・世界観・撮影クリエイト・シール・BGMが変化♡">
                <img class="img-02" :src="buildImgUrl('img_contents01_02.png')"
                     alt="Dark Romantic きらめく可憐な女神盛れ Bright Muse きらめく華やか女神盛れ">
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <div class="img-01"><img :src="buildImgUrl('img_contents02_01.png')" alt="コンセプトにぴったりなトレンドアイテム（グッズ&フレーム）を全45種類搭載！"></div>
                <div class="img-02" ><img :src="buildImgUrl('gif_contents_02_01.gif')" alt="グッズ&フレームイメージ"></div>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <img class="img-01" :src="buildImgUrl('img_contents03_01.png')"
                     alt="2つの形から選べるプリステッカーが、デザインも選べるようになったよ！　Dark Romanticイメージ">
                <img class="img-02" :src="buildImgUrl('img_contents03_02.png')"
                     alt="Bright Museイメージ">
                <img class="img-03" :src="buildImgUrl('img_contents03_03.png')"
                     alt="カラーのみのシンプルシールも継続搭載！ 2つの形で色んな使い方が楽しめる！">
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <img class="img-01" :src="buildImgUrl('img_contents04_01.png')"
                     alt="メイクが韓国トレンドカラーにリニューアルしたよ♡">
                <img class="img-02" :src="buildImgUrl('img_contents04_02.png')"
                     alt="さらに・・・「小顔」「アゴ短く」などの人気レタッチを追加搭載！">
                <img class="img-03" :src="buildImgUrl('img_contents04_03.png')"
                     alt="2つの世界観にぴったりな落書きコンテンツでアイドルっぽ可愛プリが作れちゃう♡">
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineIdolyStudio2",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        machineId() {
            return 162;
        },
        sectionTitleList() {
            return [
                '01 韓国アイドル体験がもっと楽しめる新機能♡「コンセプト選択」',
                '02 大人気機能がパワーアップ♡「撮影クリエイト」',
                '03 IDOLY好き待望のデザインシールが登場！「プリステッカー」',
                '04 定番機能もリニューアル！「メイクレタッチ&落書きコンテンツ」',
            ];
        }
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * 画像の高さを端末の幅によってセットする
         * 横幅に対しての高さの倍率を指定する
         * @param  ratio
         */
        setHeight(ratio) {
            return  window.innerWidth * ratio;
        }
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(360px, $deviceWidth));
                left: 0;
                width: 100%;

                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                    margin:0 auto;
                }
            }

            .list-anchor-link-feature-summary {
                padding: (variables.$grid-consistent * 3) 0;
                .img-link {
                    width: math.percentage(math.div(604px, $deviceWidth));
                    margin: 0 auto;
                }

                .img-line {
                    width: math.percentage(math.div(604px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
                .feature-summary {
                    width: math.percentage(math.div(604px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }
        }

        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07 {
                    display: block;
                }
                .cont-02 {
                    position: relative;
                    .img-02 {
                        position: absolute;
                        top: math.percentage(math.div(104px, $deviceWidth));
                        width: math.percentage(math.div(626px, $deviceWidth));
                        left: math.percentage(math.div(62px, $deviceWidth));
                    }
                }
            }
        }

        &-movie {
            padding: math.percentage(math.div(350px, $deviceWidth)) 0 math.percentage(math.div(110px, $deviceWidth));
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-size: cover;
            background-position: center;
            &-thumb {
                width: math.percentage(math.div(650px, $deviceWidth));
                margin: 0 auto math.percentage(math.div(70px, $deviceWidth));
            }
            &-btn-studio {
                width: math.percentage(math.div(420px, $deviceWidth));
                margin: 0 auto;
                box-shadow: 0 0 8px rgba(255, 255, 255, .3);
            }
        }
    }
}

</style>
